module.exports = __webpack_public_path__ + "img/one_5.e70c2aef.png";